var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{ref:"vxeGrid",attrs:{"auto-resize":"","highlight-hover-row":"","data":_vm.tableData,"loading":_vm.loading,"columns":_vm.tableColumns,"size":"mini","height":200,"border":"","checkbox-config":{
      highlight: true,
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }